import React from "react";

import { dateToString, stringToDate } from "utils/DateUtils";
import DatePicker from "utils/elements/DatePicker";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { DateField } from "core/field/FieldService";
import { isEmpty } from "utils/Utils";
import {
	InformationRight,
	ReportFieldRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type DateInputProps = {
	field: DateField;
	rights: ReportFieldRights;
	editable: boolean;
	onChange: (uuid: string, value: string) => void;
};

const DateInput: React.FC<DateInputProps> = (props: DateInputProps) => {
	function isValid(value: string): boolean {
		return props.field.required ? !isEmpty(value) : true;
	}

	function onChange(date: Date | null): void {
		const newValue = dateToString(date);
		props.onChange(props.field.uuid, newValue);
	}

	function toId(uuid: string): string {
		const separatorIndex = uuid.indexOf("#");
		return separatorIndex === -1 ? uuid : uuid.substring(0, separatorIndex);
	}

	return (
		<Grid container columnSpacing={2} alignItems="center">
			<Grid item>
				<Typography>{props.field.name}</Typography>
			</Grid>
			<Grid item>
				<DatePicker
					disabled={
						!props.editable ||
						props.rights[toId(props.field.uuid)][
							InformationRight.WRITE
						] === false
					}
					inputProps={{
						variant: "standard",
						fullWidth: true,
						required: props.field.required,
						error: !isValid(props.field.value)
					}}
					value={stringToDate(props.field.value)}
					onChange={onChange}
				/>
			</Grid>
		</Grid>
	);
};

export default DateInput;
